<template>
  <div>
    <page-title>Poll Results</page-title>

    <loading v-if="loading" />

    <div v-else>
      <section-block>
        <template #header>
          <h2>{{ currentPoll.title }}</h2>
        </template>

        <p>
          {{ results.length }} result<span v-if="results.length != 1">s</span>
          collected so far
        </p>

        <ol class="listless results-list" v-if="results.length > 0">
          <li v-for="choice in currentPoll.options" :key="choice.id">
            <span
              :style="{ width: `${percentages[choice.id].percentage}%` }"
              :class="{ animate: showBars }"
            />
            {{ choice.name }} ({{ percentages[choice.id].totalVotes }} -
            {{ percentages[choice.id].percentage }}%)
          </li>
        </ol>
      </section-block>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  async mounted() {
    await this.$store.dispatch("Polls/load", this.id);
    await this.$store.dispatch("Polls/getResults", this.id);
    this.calculateResults();
    this.loading = false;
    setTimeout(() => (this.showBars = true), 500);
  },
  methods: {
    calculateResults() {
      this.currentPoll.options.forEach((choice) => {
        this.percentages[choice.id] = this.calculatePercentage(choice.id);
      });
    },
    calculatePercentage(sortOrder) {
      const totalVotes = this.results.reduce((acc, curr) => {
        const answer =
          curr.options.filter((opt) => opt.id == sortOrder).length > 0 ? 1 : 0;
        return acc + answer;
      }, 0);
      return {
        percentage: Math.round((totalVotes / this.results.length) * 100),
        totalVotes,
      };
    },
  },
  computed: {
    ...mapState("Polls", ["currentPoll"]),
    ...mapGetters("Polls", ["results"]),
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      loading: true,
      showBars: false,
      percentages: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.results-list {
  li {
    position: relative;
    padding: 10px;
    z-index: 0;

    & + li {
      margin-top: 10px;
    }

    span {
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      width: 0;
      max-width: 0;
      height: 100%;
      background: $colour-nhs-pale-grey;
      transition: all ease-in-out 1s;
      transition-delay: 1s;
      z-index: -1;

      &.animate {
        max-width: 100%;
      }
    }
  }
}
</style>
